import { gql } from '@apollo/client';
import {
  GetAuthorsQuery,
  GetAuthorsQueryVariables,
} from '__generated__/queries-web';
import { useFetch } from '../../../utils/useFetch';

export const GET_AUTHORS = gql`
  query GetAuthors(
    $first: UnsignedInt!
    $where: AuthorFilterInput
    $skip: UnsignedInt
    $orderBy: [AuthorOrderingInput!]
  ) {
    authors(first: $first, where: $where, skip: $skip, orderBy: $orderBy) {
      avatarUrl
      description
      facebookId
      googleId
      hasPublicProfile
      id
      instagramId
      isMain
      linkedinId
      media
      name
      pinterestId
      snapchatId
      twitterId
      userId
    }
  }
`;

export const useGetAuthors = () =>
  useFetch<GetAuthorsQuery, GetAuthorsQueryVariables>(GET_AUTHORS);
